import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ClassTypesDropdown from "../../../components/dropdowns/ClassTypesDropdown";
import PassCard from "../../../components/passes/PassCard";
import PaymentForPassModal from "../../../components/modals/PaymentForPassModal";
import $ from "jquery";

const PassesList = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState(null);
    const { checkServerData, changeView } = useContext(BasicContext);
    const [selectedPassType, setSelectedPassType] = useState([]);
    const [showPaymentForPassModal, setShowPaymentForPassModal] = useState(false);
    const [privillege, setPrivillege] = useState(null);

    const getPassesList = async () => {
        const res = await postMethod("/get-passes-list");
        if (checkServerData(res)) {
            setList(res.data.list);
            setPrivillege(res.data.purchasePassPriv);
        }
        setLoading(false);
    };

    useEffect(() => {
        getPassesList();
        // eslint-disable-next-line
    }, []);

    const filterList = (e) => {
        const searchForTypes = (type) => {
            let ifPassHasType = false;
            type.forEach((pt) => {
                selectedPassType.forEach((spt) => {
                    if (spt === pt.class_type_code) ifPassHasType = true;
                });
            });
            return ifPassHasType;
        };
        if (selectedPassType.length === 0 || searchForTypes(e.class_types)) return true;
        else return false;
    };

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 mt-3 px-lg-2 ">
                                <ClassTypesDropdown onChange={(v) => setSelectedPassType(v)} value={selectedPassType} multiple id="passType" label={t("classes.classesTypes")} />
                            </Col>
                        </Row>
                        <Row>
                            {list.filter(filterList).length > 0 ? (
                                <Fragment>
                                    {list.filter(filterList).map((e, i) => (
                                        <Col xs={12} lg={6} className="" key={i}>
                                            <PassCard pass={e} i={i} allowedPermission={privillege} onProceed={() => setShowPaymentForPassModal(e)} />
                                        </Col>
                                    ))}
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}

            {showPaymentForPassModal && (
                <PaymentForPassModal
                    pass={showPaymentForPassModal}
                    onClose={() => {
                        $(".pass-card").removeClass("selected-pass");
                        setShowPaymentForPassModal(false);
                    }}
                    onProceed={() => {
                        setShowPaymentForPassModal(false);
                        changeView({ nav: "schedule", sub: "main", params: { moduleName: "APP" } });
                    }}
                />
            )}
        </Fragment>
    );
};

export default PassesList;
